import { apiClient, apiPdf } from '@/services';

export const DirectDebitService = {
  loadDirectDebit() {
    return apiClient.get('/direct_debit/');
  },
  getDirectDebitPdf() {
    return apiPdf.get('/direct_debit/pdf');
  },
};